import React from 'react'
import banner from '../../assets/logo/banner1.png'

function Banner() {
    return (
       <div className=''><img className='banner' src={banner} alt="" /></div>
    )
}

export default Banner